/* @refresh reset */
import { Icon } from "./";
import React, { useState, useEffect } from "react";
export function TagInput({
  value,
  onChange,
  separateEntry,
  tagOnEnter,
  tagOnTab = true,
  tagOnComma = true,
  objectMode,
  labelField,
  valueField,
  transform,
  disallowHashes,
  // onlyUnique,
}) {
  let initialState = value;
  if (!value) {
    initialState = [];
  }
  if (!Array.isArray(value)) {
    initialState = [value];
  }
  // const isStringMode = value && typeof value === 'string' ? true : false;

  const tagKeys = [];
  if (tagOnComma) {
    tagKeys.push(",");
  }
  if (tagOnTab) {
    tagKeys.push("Tab");
  }
  if (tagOnEnter || tagKeys.length === 0) {
    tagKeys.push("Enter");
  }

  const [tags, setTags] = useState(initialState);
  const [tagInputValue, setTagInputValue] = useState("");
  const [isKeyReleased, setIsKeyReleased] = useState(false);

  const handleKeyDown = (e) => {
    const { key } = e;
    let trimmedInput = tagInputValue.trim();

    if (tagKeys.includes(key)) {
      e.preventDefault();
      if (trimmedInput.length && !tags.includes(trimmedInput)) {
        if (disallowHashes && trimmedInput.indexOf("#") > -1) {
          // console.log('Remove all hashes!');
          trimmedInput = trimmedInput.replace(/\#/gim, "");
          // console.log('Removed: ', trimmedInput);
        }
        setTags((prevState) => [...prevState, trimmedInput]);
        setTagInputValue("");
      }
    }

    if (
      key === "Backspace" &&
      !tagInputValue.length &&
      tags.length &&
      isKeyReleased
    ) {
      const tagsCopy = [...tags];
      const poppedTag = tagsCopy.pop();
      e.preventDefault();
      setTags(tagsCopy);
      setTagInputValue(poppedTag);
    }

    setIsKeyReleased(false);
  };

  const handleKeyUp = (e) => {
    setIsKeyReleased(true);
  };

  const handleTagInputChange = (e) => {
    setTagInputValue(e.target.value);
  };

  const remove = (index) => {
    // console.log('Removing tag at index', index);
    setTags((prevState) => prevState.filter((tag, i) => i !== index));
  };

  useEffect(() => {
    if (onChange) {
      onChange(tags);
    }
  }, [tags]);

  return (
    <div className="chronos-tag-input-component">
      {separateEntry && (
        <div className="chronos-tag-input-list">
          {tags.map((tag, i) => (
            <Tag
              content={tag}
              objectMode={objectMode}
              labelField={labelField}
              valueField={valueField}
              remove={() => remove(i)}
              transform={transform}
              key={i}
            />
          ))}
        </div>
      )}
      <div className="chronos-tag-input-wrapper">
        {!separateEntry && (
          <React.Fragment>
            {tags.map((tag, i) => (
              <Tag
                content={tag}
                objectMode={objectMode}
                labelField={labelField}
                valueField={valueField}
                remove={() => remove(i)}
                transform={transform}
                key={i}
              />
            ))}
          </React.Fragment>
        )}
        <input
          type="text"
          value={tagInputValue}
          onChange={handleTagInputChange}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
      </div>
      <div className="chronos-tag-input-help">
        {tagKeys && tagKeys.length > 0 && (
          <React.Fragment>
            <span>Press&nbsp;</span>
            {tagKeys.map((key, i) => (
              <React.Fragment key={i}>
                {i !== 0 ? "," : ""}
                {i === tagKeys.length - 1 && " or "}
                <kbd key={i} className="chronos-tag">
                  {key}
                </kbd>
              </React.Fragment>
            ))}
            <span>&nbsp;to add a tag.</span>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

function Tag({
  content,
  remove,
  transform,
  objectMode,
  labelField,
  // valueField,
}) {
  const style =
    transform && transform.length > 0 ? { textTransform: transform } : {};

  return (
    <div className="chronos-tag-input-tag" style={style}>
      <span className="chronos-tag-label">
        {!objectMode && content}
        {objectMode && content[labelField]}
      </span>
      <button type="button" onClick={remove}>
        <Icon icon="far fa-times fa-fw" />
      </button>
    </div>
  );
}
